


























import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator';
import unsavedDetector from '@/pro/directives/input/unsavedDetector';

@Component({
  directives: { unsavedDetector },
})
export default class NumberInput extends Vue {
  @Prop({ default: '150px' })
  private width!: string;
  @Prop({ default: 'left' })
  private readonly textAlign: 'left' | 'right' | 'center';
  @Prop({ default: 0 })
  private maxLength!: number;
  @Prop({ default: false })
  private disabled!: boolean;
  @Prop({ default: false })
  private readonly!: boolean;
  @Prop({ default: '' })
  private placeholder!: string;
  @Prop({ default: '' })
  private name!: string;
  @Prop({ default: '' })
  private value!: string | number;
  @Prop({ default: null })
  private valueChangedHook: (value?: string) => void;
  /** just blur event */
  @Prop({ default: null })
  private valueChangedHookWhenBlur: (value?: string) => void;
  /** if it's invalid reset value,  */
  @Prop({ default: null })
  private validateOnBlur: (value?: string) => boolean;
  @Prop({ default: false })
  private id!: string | false; // false 시 id 렌더 안함
  @Prop({ default: null })
  private tabIndex!: number;
  @Prop({ default: '' })
  private className: string;
  @Prop({ default: 0 })
  private fractionDigits: number;
  @Prop({ default: false })
  private omitThousandSeparator: boolean;

  @Ref('input')
  readonly input: HTMLInputElement;

  private internalValue: string = this.value?.toString() ?? '';
  private isFocused: boolean = false;

  private get listeners(): Record<string, Function | Function[]> {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { input, ...listeners } = this.$listeners;
    return listeners;
  }

  private formatNumber(value: string): string {
    if (!value) return '';

    const raw = value.replace(/,/g, '');
    // 실수 케이스 고려
    const [integerPart, decimalPart] = raw.split('.');
    // 정수 부분에 콤마 추가
    const formattedInt = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return !!decimalPart ? `${formattedInt}.${decimalPart}` : formattedInt;
  }

  @Watch('value', { immediate: true })
  private onValueChanged(value: string | number): void {
    this.internalValue = value?.toString() ?? '';
  }

  get displayValue(): string {
    if (this.omitThousandSeparator) {
      return this.internalValue;
    }

    return this.isFocused ? this.internalValue : this.formatNumber(this.internalValue);
  }

  private onChange(e: Event) {
    const target = e.target as HTMLInputElement;
    const $el = this.input;
    const regex = this.fractionDigits > 0 ? /[^0-9.]/g : /[^0-9]/g;
    // 우선 콤마 제거 (포커스 해제 상태에서 복사해서 포커스 시 들어올 경우 대비)
    $el.value = target.value.replace(/,/g, '');
    $el.value = target.value.replace(regex, '');

    if (this.fractionDigits > 0) {
      // 온점(.)이 여러 개일 경우 첫 번째 온점만 남기고 제거
      const parts = target.value.split('.');
      if (parts.length > 2) {
        $el.value = parts.shift() + '.' + parts.join('');
      }

      // 소수점 이하 fractionDigits으로 설정한 자리까지만 허용
      if (target.value.includes('.')) {
        const [integer, decimals] = target.value.split('.');
        if (decimals.length > this.fractionDigits) {
          $el.value = integer + '.' + decimals.slice(0, this.fractionDigits);
        }
      }
    }

    const maxLength = Number(this.maxLength);
    if (!!maxLength && target.value?.length > maxLength) {
      $el.value = $el.value.slice(0, maxLength);
    }

    if (this.valueChangedHook) this.valueChangedHook($el.value);
    this.internalValue = $el.value;
    this.$emit('input', $el.value);
  }

  public onFocus(): void {
    const $el = this.input;
    this.isFocused = true;
    $el.focus();
  }

  public onBlur(e: Event) {
    const target = e.target as HTMLInputElement;
    const $el = this.input;

    if(target.value && target.value.at(-1) === '.') {
      this.value = target.value.slice(0, -1);
    }

    if(this.validateOnBlur && !this.validateOnBlur($el.value)) {
      this.value = 0;
    }

    if (this.valueChangedHookWhenBlur) {
      this.valueChangedHookWhenBlur($el.value);
      this.$emit('on-input-blur', $el.value);
    }
    this.isFocused = false;
  }
}
